<app-infobox-table [data]="computeInfoboxData()"></app-infobox-table>

<p class="p-text-secondary">Note: Components are shown in dollars per unit</p>

<app-components-table [data]="details"></app-components-table>
